module.exports = __webpack_public_path__ + "img/mapbg.6b15ca24.png";